import { RouteRecordRaw } from 'vue-router';

import { AppRouteNames, AppRoutes } from '@tallo/investor/navigation';

export const oldRoutes: RouteRecordRaw[] = [
  {
    path: '/sign-in',
    redirect: AppRoutes.SIGN_IN,
  },
  {
    path: '/reset-password',
    redirect: AppRoutes.RESET_PASSWORD,
  },
  {
    path: '/reset-password/confirm',
    redirect: AppRoutes.RESET_PASSWORD_CONFIRM,
  },
  {
    path: '/this-is-our-very-secret-backdoor-sign-up-link',
    redirect: AppRoutes.SIGN_UP,
  },
  {
    path: '/this-is-our-very-secret-backdoor-sign-up-link/confirm-email',
    redirect: AppRoutes.SIGN_UP_CONFIRM_EMAIL,
  },
  {
    path: '/investor/:any*',
    redirect: (to) => to.fullPath.replace('/investor', ''),
  },
  {
    path: '/property/:propertyId/status',
    redirect: { name: AppRouteNames.INVESTOR_PROPERTY_DASHBOARD },
  },
];
